import { Controller } from "@hotwired/stimulus";

class DoofinderRecommendations extends Controller {
  static targets = ["swiper", "wrapper", "pagination", "nextBtn", "prevBtn"];

  connect() {
    this.initSwiper();
  }

  disconnect() {
    this.swiper?.destroy();
  }

  initSwiper() {
    const swiperConf = {
      spaceBetween: 10,
      slidesPerView: "auto",
      loop: true,
      navigation: {
        nextEl: this.nextBtnTarget,
        prevEl: this.prevBtnTarget,
      },
      pagination: {
        el: this.paginationTarget,
        bulletClass:
          "swiper-pagination-bullet tw:border tw:border-blue-700 tw:bg-transparent tw:opacity-100",
        bulletActiveClass: "tw:bg-blue-700!",
        clickable: true,
      },
    };

    const parentEl = this.element.closest("[data-slides-small]");
    if (parentEl) {
      swiperConf.breakpoints = {
        0: { slidesPerView: parentEl.dataset.slidesSmall },
        640: { slidesPerView: parentEl.dataset.slidesMedium },
        1024: { slidesPerView: parentEl.dataset.slidesLarge },
        1280: { slidesPerView: parentEl.dataset.slidesLarge },
      };
    }

    this.swiper = new Swiper(this.swiperTarget, swiperConf);
  }
}

Stimulus.register("dooRecommendations", DoofinderRecommendations);
